export default {
  action_plan: 'Action plan',
  // Date Time
  month: 'month',
  month_plural: 'months',
  day: 'day',
  day_plural: 'days',
  hour: 'hour',
  hour_plural: 'hours',
  minute: 'minute',
  minute_plural: 'minutes',

  // Profiles
  'profiles.owner': 'Owner',
  'profiles.thirdParty': 'Third Party',
  'profiles.thirdPartyUser': 'Third Party User',
  'profiles.user': 'User',
  'profiles.administrator': 'Administrator',
  'profiles.administrative': 'Administrative',

  // Filters
  'filter.createdBy': 'Created by {{count}} user',
  'filter.createdBy_plural': 'Created By {{count}} users',
  'filter.assetIds': '{{count}} asset',
  'filter.assetIds_plural': '{{count}} assets',

  // Entities
  'entity.formReply': 'Form replies',
  'entity.serviceOrder': 'Service orders',
  'entity.user': 'Users',
  'entity.service': 'Checklists',
  'entity.refund': 'Refunds',
  'entity.person': 'People',
  'entity.fleet': 'Fleet',
  'entity.location': 'Places',
  // Field types
  'fieldTypes.action_plan': 'Action plan',
  'fieldTypes.checkbox': 'Yes or no',
  'fieldTypes.compliance': 'Compliance',
  'fieldTypes.cpf_cnpj': 'Document',
  'fieldTypes.gallery': 'Attachments',
  'fieldTypes.location': 'Address',
  'fieldTypes.numeric': 'Decimal',
  'fieldTypes.multiple': 'Multiple select',
  'fieldTypes.pending': 'Pendency',
  'fieldTypes.select': 'Select',
  'fieldTypes.sign': 'Signature',
  'fieldTypes.signature': 'Signature (profile)',
  'fieldTypes.system_status': 'System Status',
  'fieldTypes.address': 'Address',
  'fieldTypes.integer': 'Integer',
  'fieldTypes.float': 'Decimal',
  'fieldTypes.text': 'Text',
  'fieldTypes.date': 'Date',
  'fieldTypes.time': 'Time',
  'fieldTypes.datetime': 'Date and Time',
  'fieldTypes.email': 'Email',
  'fieldTypes.picture': 'Picture',
  'fieldTypes.file': 'File',
  'fieldTypes.phoneNumber': 'Phone',
  'fieldTypes.assets': 'Assets',
  'fieldTypes.calc': 'Calc',
  'fieldTypes.integration': 'Integration',
  'fieldTypes.coordinates': 'Coordinates',
  'fieldTypes.validation_code': 'Validation code',

  // Field types descriptions for tooltips
  'fieldTypes.action_plan.description': 'Field for creating action plans and tracking pending items',
  'fieldTypes.block.description': 'Groups questions in table format for theme items',
  'fieldTypes.asset.description': 'Selection of registered items for resource tracking',
  'fieldTypes.checkbox.description': 'Two predefined and editable fixed options (Compliant/Non-Compliant)',
  'fieldTypes.date.description': 'Date format field for selection',
  'fieldTypes.datetime.description': 'Date and time format field for selection',
  'fieldTypes.time.description': 'Field for time selection',
  'fieldTypes.gallery.description': 'Attach photos or .docx, .xlsx, .pptx and PDF files',
  'fieldTypes.pending.description': 'Field for registering pending items and tracking',
  'fieldTypes.multiple.description': 'Select one or multiple options from predefined list',
  'fieldTypes.stock.description': 'Automatically updates stock control',
  'fieldTypes.select.description': 'Allows choosing only one option from predefined list',
  'fieldTypes.sign.description': 'Field for digital signature by user',
  'fieldTypes.signature.description': 'Signature stored in user profile (draw and save as PNG)',
  'fieldTypes.address.description': 'Field for complete address filling',
  'fieldTypes.location.description': 'Captures location via Google Maps with geolocation',
  'fieldTypes.numeric.description': 'Exclusive field for integer numbers',
  'fieldTypes.integer.description': 'Field for integer numbers',
  'fieldTypes.float.description': 'Accepts numbers with or without comma',
  'fieldTypes.text.description': 'Free field for inserting textual information',
  'fieldTypes.place.description': 'Select places previously registered on the platform',
  'fieldTypes.tags.description': 'Field for classification with tags',
  'fieldTypes.informative.description': 'Shows instructions or warnings without user interaction',
  'fieldTypes.user.description': 'Select users previously registered on the platform',
  'fieldTypes.calc.description': 'Executes automatic numerical calculations through formula',
  'fieldTypes.integration.description': 'Contact our technical team to bring external information',
  'fieldTypes.cpf_cnpj.description': 'Automatic insertion and validation of CPF or CNPJ',
  'fieldTypes.coordinates.description': 'Captures your current location at the time of response.',
  'fieldTypes.validation_code.description': 'Field to enter a code validated against the activity.',
  'fieldTypes.cCodCateg': 'Category',
  'fieldTypes.nCodCC': 'Current Account Code',
  'fieldTypes.nQtdeParc': 'Installments',
  'fieldTypes.cCodServMun': 'Service or CNAE Code',
  'fieldTypes.cCodServLC116': 'LC 116 Service Code',
  'fieldTypes.cTribServ': 'Services Taxation',
  'fieldTypes.codVend': 'Sellers',
  'fieldTypes.projects': 'Projects',
  'fieldTypes.documentType': 'Document type',

  // Conditions
  'conditions.emptyUser': 'empty',

  // Places
  place: 'Place',
  place_person: 'Person',

  // Date
  createdAt: 'Created at',
  'pdf.repliedAt': 'Replied at {{date}}',
  updatedAt: 'Updated at',
  removedBy: 'Removed by',

  // Views
  'views.list': 'List view',
  'views.calendar': 'Calendar view',
  'views.listReplies': 'List replies view',
  'views.graphics': 'Graphics view',
  newKanban: 'New Kanban',

  // Widgets
  'widgets.considering': 'Considering: ',
  'widgets.allTime': 'All time',
  'widgets.perspective': 'Perspective',
  'widgets.byHour': 'By hour',
  'widgets.byDay': 'By day',
  'widgets.byMonth': 'By month',
  'widgets.byYear': 'By year',
  'widgets.activities': 'Activities',
  'widgets.forms': 'Forms',
  'widgets.presentation': 'Presentation',
  'widgets.color': 'Color',
  'widgets.filters': 'Filters',
  'widgets.ignorePeriod': 'Ignore period?',
  'widgets.counterOnly': 'Counter only',
  'widgets.percentageBar': 'Percentage bar',
  'widgets.circularPercentage': 'Circular percentage',
  'widgets.lines': 'Lines',
  'widgets.bars': 'Bars',
  'widgets.initialPerspective': 'Initial perspective',
  'widgets.hidePerspectiveSelection': 'Hide perspective selection?',
  'widgets.name': 'Name',
  'widgets.completed': 'Completed',
  'widgets.open': 'Open',
  'widgets.pending': 'Pending',
  'widgets.compliancesCounter.name': 'Non-compliance percentage',
  'widgets.compliancesCounter.description': 'Lorem Ipsum',
  'widgets.compliancesCounter.category': 'Compliance',
  'widgets.serviceOrdersCounter.name': 'Activities count',
  'widgets.serviceOrdersCounter.description': 'Lorem Ipsum',
  'widgets.serviceOrdersCounter.category': 'Activities',
  'widgets.serviceOrdersCounter.initialStateName': 'Activities',
  'widgets.noPreview': 'This widget has no preview',
  'widgets.nonCompliancesCounter.name': 'Non-compliances count',
  'widgets.nonCompliancesCounter.description': 'Lorem Ipsum',
  'widgets.nonCompliancesCounter.category': 'Compliance',
  'widgets.nonCompliancesCounter.initialStateName': 'Non-compliances',
  'widgets.usersCounter.name': 'Users count',
  'widgets.usersCounter.description': 'Lorem Ipsum',
  'widgets.usersCounter.category': 'Users',
  'widgets.usersCounter.initialStateName': 'Users',
  'widgets.placesCounter.name': 'Places count',
  'widgets.placesCounter.description': 'Lorem Ipsum',
  'widgets.placesCounter.category': 'Places',
  'widgets.placesCounter.initialStateName': 'Places',
  'widgets.formsCounter.name': 'Forms count',
  'widgets.formsCounter.description': 'Lorem Ipsum',
  'widgets.formsCounter.category': 'Forms',
  'widgets.formsCounter.initialStateName': 'Forms',
  'widgets.formRepliesCounter.name': 'Form replies count',
  'widgets.formRepliesCounter.description': 'Lorem Ipsum',
  'widgets.formRepliesCounter.category': 'Forms',
  'widgets.formRepliesCounter.initialStateName': 'Form replies',
  'widgets.groupedEventsByReason.name': 'Events grouped by reason',
  'widgets.groupedEventsByReason.description': 'Lorem Ipsum',
  'widgets.groupedEventsByReason.category': 'Activities',
  'widgets.averageEventsAmountByPeriod.name': 'Average activities executed per period',
  'widgets.averageEventsAmountByPeriod.description': 'Lorem Ipsum',
  'widgets.averageEventsAmountByPeriod.category': 'Activities',
  'widgets.averageFormRepliesAmountByPeriod.name': 'Average form replies per period',
  'widgets.averageFormRepliesAmountByPeriod.description': 'Lorem Ipsum',
  'widgets.averageFormRepliesAmountByPeriod.category': 'Forms',
  'widgets.periodicFormReplies.name': 'Form replies volume per period',
  'widgets.periodicFormReplies.description': 'Lorem Ipsum',
  'widgets.periodicFormReplies.category': 'Forms',
  'widgets.periodicServiceOrdersByStatus.name': 'Activities volume by status',
  'widgets.periodicServiceOrdersByStatus.description': 'Lorem Ipsum',
  'widgets.periodicServiceOrdersByStatus.category': 'Activities',
  'widgets.periodicNonCompliances.name': 'Non-compliances volume per period',
  'widgets.periodicNonCompliances.description': 'Lorem Ipsum',
  'widgets.periodicNonCompliances.category': 'Compliance',
  'widgets.groupedNonCompliances.name': 'Non-compliances by entity',
  'widgets.groupedNonCompliances.description': 'Lorem Ipsum',
  'widgets.groupedNonCompliances.category': 'Compliance',
  'widgets.ranking.name': 'Ranking',
  'widgets.ranking.description': 'Lorem Ipsum',
  'widgets.usersRanking.name': 'Users ranking',
  'widgets.usersRanking.category': 'Users',
  'widgets.placesRanking.name': 'Places ranking',
  'widgets.placesRanking.category': 'Places',
  'widgets.checklistsRanking.name': 'Checklists ranking',
  'widgets.checklistsRanking.category': 'Checklists',
  'widgets.embed.name': 'Embedded content',
  'widgets.embed.description': 'This widget allows embedding content from inside and outside Btime.',
  'widgets.embed.category': 'Embed',
  'widgets.embed.initialStateName': 'Embedded content',
  'widgets.status': 'Status',
  'widgets.all': 'All',
  'widgets.done': 'Completed',
  'widgets.type': 'Type',
  'widgets.groupedBy': 'Grouped by',
  'widgets.evaluatedCompliances': 'Evaluated compliances',
  'widgets.nonCompliances': 'Non-compliances',
  'widgets.canceled': 'Canceled',
  'widgets.questionnaire': 'Questionnaire',
  'widgets.locals': 'Places',
  'widgets.user': 'User',
  'widgets.invertPerspective': 'Invert perspective?',
  'widgets.period': 'Period',
  'widgets.timeOfDay': 'Time of day',
  'widgets.dayOfWeek': 'Day of week',
  'widgets.barColor': 'Bar color',
  'widgets.url': 'URL*',
  'widgets.rejected': 'Rejected',
  'widgets.approved': 'Approved',
  'widgets.openings': 'Openings',
  'widgets.completions': 'Completions',
  'widgets.discontinuations': 'Discontinuations',
  'widgets.total': 'Total',
  'widgets.removeScreenItem.confirm': 'Are you sure you want to remove?',
  'widgets.removeScreenItem.success': 'Screen removed successfully!',
  'widgets.removeScreenItem.error': 'An error occurred while removing!',

  // Filters and lists
  betaVersionMessage: 'This is a beta version of this page',
  useOldVersion: 'Use old version',

  itemsFound: '{{count}} item found',
  itemsFound_plural: '{{count}} items found',

  emptyMessage: 'Nothing found!',
  errorMessage: 'Something went wrong while connecting to the server!',

  // Device info
  deviceModel: 'Model',
  battery: 'Battery',
  application: 'Application',
  storage: 'Storage',

  cleanDate: 'Clear date',
  selectInitDate: 'Select begin date',
  selectEndDate: 'Select end date',

  showAll: 'Show all',
  showOnly: 'Show only',
  clean: 'Clean',
  applyFilters: 'Apply Filters',
  filterBy: 'Filter by',
  sortBy: 'Sort by',
  ASC: 'Ascending',
  DESC: 'Descneding',
  cleanFilters: 'Clean filters',
  filter: 'Filter',
  sort: 'Sort',
  search: 'Search',
  selectAll: 'Select all',
  selected: 'Selected',
  selected_plural: 'Selecteds',

  //Non Compliance
  openActionPlan: 'Open action plan',
  lastReplies: 'Last replies',
  ignoreNonCompliance: 'Ignore',
  completeNonCompliance: 'Complete',
  markAsCompleted: 'Mark as completed',
  createActionPlan: 'Create Action Plan',
  removeIgnoreNonCompliance: `Don't ignore`,
  'option.replies': 'Replies',
  'option.serviceOrders': 'Service Orders',

  // General
  metrics: 'Metrics',
  rest: 'Rest',
  pay: 'Pay',
  files: 'Files',
  clone: 'Clone',
  export: 'Exportar',
  reply: 'Reply',
  details: 'Details',
  questions: 'Quesitions',
  simulation: 'Simulation',
  noUser: 'No User',
  noPlace: 'No Place',
  changeUser: 'Change User',
  execute: 'Execute',
  executeInBulk: 'Bulk execute',
  reopen: 'Reopen',
  resume: 'Resume',
  public: 'Public',
  private: 'Private',
  close: 'Close',
  branch: 'Branch',
  headquarter: 'Headquarter',
  sendQrCodes: 'Send QrCodes',
  minimum: 'Min: {{count}}',
  maximum: 'Max: {{count}}',
  tryAgain: 'Try again',
  print: 'Print',
  create: 'Create',
  update: 'Update',
  sendForm: 'Send Form',
  send: 'Send',
  begin: 'Begin',
  person: 'Person',
  location: 'Place',
  types: 'Types',
  share: 'Share',
  assets: 'Assets',
  field: 'Field',
  fields: 'Fields',
  seeDetails: 'See details',
  remove: 'Remove',
  actions: 'Actions',
  moreOptions: 'More Options',
  addPhoto: 'Add Photo',
  yes: 'Yes',
  no: 'No',
  active: 'Active',
  inactive: 'Inactive',
  notAvailable: 'N/A',
  fieldInDevelopment: 'Field under development',
  required: 'Required',
  pause: 'Pause',
  saveAndPause: 'Save and Pause',
  submit: 'Submit',
  edit: 'Edit',
  cancel: 'Cancel',
  confirm: 'Confirm',
  save: 'Save',

  // Question types
  'questions.types.checkbox': 'Checkbox',
  'questions.types.compliance': 'Compliance',
  'questions.types.text': 'Text',
  'questions.types.gallery': 'Pictures',
  'questions.types.number': 'Number',
  'questions.types.sign': 'Signature',

  // Question answers
  'questions.answers.yes': 'Yes',
  'questions.answers.no': 'No',

  // Actions
  changePassword: 'Change password',
  logs: 'Logs',
  generateCustomDocument: 'Generate Custom Document',
  sendPublicLink: 'Send public link',
  sendPublicLinks: 'Send public links',
  sendFormFull: 'Send form',
  generateQRCode: 'Generate QR Code',
  generateQRCodes: 'Generate QR Codes',
  createActivities: 'Create activities',
  saveAsTemplate: 'Save as template',
  recoverUser: 'Recover user',
  reinstall: 'Reinstall',
  registerTechnician: 'Register Technician',
  viewTechnicians: 'View Technicians',

  // Status
  // Status
  changeStatus: 'Change Status',
  approval: 'Aprovação',
  approve: 'Approve',
  disapprove: 'Disapprove',
  'status.action.approve': 'Approve',
  'status.action.disapprove': 'Disapprove',
  'status.action.canceled': 'Cancelar',
  'status.pastAction.request': 'Abriu solicitação',
  'status.pastAction.open': 'open',
  'status.pastAction.received': 'received',
  'status.pastAction.accept': 'accepted',
  'status.pastAction.refused': 'refused',
  'status.pastAction.execution': 'executed',
  'status.pastAction.pause': 'pausou',
  'status.pastAction.unproductive': 'marcou como improdutiva',
  'status.pastAction.completed': 'concluiu',
  'status.pastAction.pending': 'deixou pendente',
  'status.pastAction.canceled': 'cancelou',
  'status.pastAction.approved': 'aprovou',
  'status.pastAction.disapproved': 'reprovadou',
  'status.pastAction.resolved': 'resolvel',
  'status.pastAction.unresolved': 'marcou como não resolvida',
  'status.pastAction.actionPlan': 'criou plano de ação',
  'status.pastAction.closing': 'encerrou',
  'status.all': 'Todas',
  'status.request': 'Request',
  'status.open': 'Open',
  'status.received': 'Received',
  'status.accept': 'Accepted',
  'status.refused': 'Refused',
  'status.execution': 'Execution',
  'status.pause': 'Paused',
  'status.unproductive': 'Unprofuctive',
  'status.completed': 'Completed',
  'status.pending': 'Pending',
  'status.canceled': 'Canceled',
  'status.approved': 'Approved',
  'status.disapproved': 'Disapproved',
  'status.resolved': 'Resolved',
  'status.unresolved': 'Unresolved',
  'status.actionPlan': 'Plano de Ação',
  'status.request_plural': 'Requests',
  'status.open_plural': 'Open',
  'status.received_plural': 'Receiveds',
  'status.accept_plural': 'Accepteds',
  'status.refused_plural': 'Refuseds',
  'status.execution_plural': 'Executions',
  'status.pause_plural': 'Pauseds',
  'status.unproductive_plural': 'Unproductives',
  'status.completed_plural': 'Conpleteds',
  'status.pending_plural': 'Pending',
  'status.canceled_plural': 'Canceleds',
  'status.approved_plural': 'Approveds',
  'status.disapproved_plural': 'Disapproveds',
  'status.resolved_plural': 'Resolveds',
  'status.unresolved_plural': 'Unresolveds',
  'status.actionPlan_plural': 'Action Plans',
  'status.closing': 'Closing',
  'status.closing_plural': 'Closings',

  'status.ignored': 'Ignored',
  'status.ignored_plural': 'Ignored',

  'status.inProgress': 'In progress',
  'status.inProgress_plural': 'In progress',

  'priority.critical': 'Critical',
  'priority.high': 'High',
  'priority.medium': 'Medium',
  'priority.low': 'Low',

  // Actions
  complete: 'Complete',
  generatePDFSummary: 'Generate Summary PDF',
  createChildActivity: 'Create child',

  'month.1': 'Jan',
  'month.2': 'Feb',
  'month.3': 'Mar',
  'month.4': 'Apr',
  'month.5': 'May',
  'month.6': 'Jun',
  'month.7': 'Jul',
  'month.8': 'Aug',
  'month.9': 'Sep',
  'month.10': 'Oct',
  'month.11': 'Nov',
  'month.12': 'Dec',

  'counter.text': 'Registers found',

  requeue_failed_tasks: 'Requeue failed tasks',
  retry_failed_confirm: 'Are you sure you want to rerun the failed tasks?',

  // Errors
  error: 'Error',
  'errors.duplicateRecord': 'Cannot add duplicate records!',
  'errors.cannotRemoveHasUsers': 'Could not remove. There is at least one user with this item.',
  insufficientAmount: 'Insufficient amount',
  valueMustBeGreaterThanZero: 'Amount must be greater than zero',
  'assets.generateQrCode': 'Generate QR Code',
  'assets.generateQrCodes': 'Generate QR Codes',
  'processes.remove.success': 'Process removed successfully!',
  'screens.remove.success': 'Screen removed successfully!',
  'screenViews.remove.success': 'View removed successfully!',
  'errors.remove': 'An error occurred while removing!',
  confirmRemove: 'Are you sure you want to remove?',
  errorDelete: 'An error occurred while deleting!',
  removeSuccess: 'Removed successfully!',
  clearSelection: 'Clear selection',

  'serviceOrders.removeModal.title': 'The following activities will be removed',
  'serviceOrders.removeModal.description': 'When removing an activity, its children will also be removed',
  'serviceOrders.removeActivities': 'Remove activities',
  removeInitialValue: 'Remove initial value',

  'routines.confirmRemove': 'Are you sure you want to remove the routine {{name}}?',
  'routines.removeError': 'An error occurred while removing the routine!',

  // ModalPicker
  selectOneOrMore: 'Select one or more:',
  include: 'Include',
  disabled: 'Disabled',
  deleted: 'Deleted',

  // IconPicker
  selectOne: 'Select one',
  icon: 'icon',
  removeSelection: 'Remove selection',

  // LevelSection
  levelConfiguration: 'Level Configuration',
  selectLevelToApplyConfiguration: 'Select a level to apply this configuration only to selected levels.',
  type: 'Type',
  level: 'Level',

  // Common entities
  activities: 'Activities',
  user: 'User',
  users: 'Users',
  group: 'Group',
  status: 'Status',
  tag: 'Tag',
  selectStatus: 'Status selection',
  automatic: 'Automatic',
  asset: 'Asset',
  views: 'Views',
  places: 'Places',
  people: 'People',
  fleets: 'Fleets',
  creationDate: 'Creation date',
  schedulingDate: 'Scheduling date',
  completionDate: 'Completion date',
  dates: '{{count}} dates',
  opening: 'Opening',
  sla: 'SLA',
  overdue: 'Overdue',
  id: 'ID',
  showDeleted: 'Show deleted',
  documentsCount: '{{count}} document(s)',
  actionPlansCount: '{{count}} action plan(s)',
  'config.service_order_started_since_colors.normal': 'Normal',
  'config.service_order_started_since_colors.warning': 'Warning',
  'config.service_order_started_since_colors.critic': 'Critical',

  // Date Picker
  'datePicker.selectDate': 'Date selection',
  'datePicker.suggestions': 'Suggestions',
  'datePicker.today': 'Today',
  'datePicker.yesterday': 'Yesterday',
  'datePicker.currentWeek': 'Current week',
  'datePicker.lastWeek': 'Last week',
  'datePicker.currentMonth': 'Current month',
  'datePicker.lastMonth': 'Last month',
  'datePicker.currentQuarter': 'Current quarter',
  'datePicker.lastQuarter': 'Last quarter',
  'datePicker.currentYear': 'Current year',
  'datePicker.lastYear': 'Last year',
  'datePicker.last3Years': 'Last 3 years',
  'datePicker.last5Years': 'Last 5 years',
  'datePicker.next7Days': 'Next 7 days',
  reopenActivity: 'Reopen Activity',
  finish: 'Finish',

  // Modals
  'modals.editingUser': 'Editing user',
  'modals.creatingUser': 'Creating user',
  'modals.changingPassword': 'Changing password',
  'modals.editingUsers': 'Editing users',
  'modals.registeringUsers': 'Registering users',
  'modals.editGroup': 'Edit Group',
  'modals.createGroup': 'Create Group',
  'modals.editChecklistCategory': 'Edit Checklist Category',
  'modals.createChecklistCategory': 'Create Checklist Category',
  'modals.editMinicrud': 'Edit',
  'modals.createMinicrud': 'Create',
  'modals.editingPlace': 'Editing place',
  'modals.creatingPlace': 'Creating place',
  'modals.customizeLevels': 'Customize levels',
  'modals.editingPlaceLevel': 'Editing place level',
  'modals.creatingPlaceLevel': 'Creating place level',
  'modals.editingTag': 'Editing tag',
  'modals.creatingTag': 'Creating tag',
  'modals.tagsList': 'Activity Tags',
  'modals.editingPlaceType': 'Editing Place type',
  'modals.creatingPlaceType': 'Creating Place type',
  'modals.registeringItems': 'Registering Items',
  'modals.editingProfile': 'Editing profile',
  'modals.creatingProfile': 'Creating profile',
  'modals.cloningProcess': 'Cloning process',
  'modals.editingProcess': 'Editing process',
  'modals.creatingProcess': 'Creating process',
  'modals.cloningScreen': 'Cloning screen',
  'modals.editingScreen': 'Editing screen',
  'modals.creatingScreen': 'Creating screen',
  'modals.cloningColumn': 'Cloning column',
  'modals.editingColumn': 'Editing column',
  'modals.creatingColumn': 'Creating column',
  'modals.editingWidget': 'Editing widget',
  'modals.addingWidget': 'Adding widget',
  'modals.editingServiceOrderUser': 'Editing Responsible User',
  'modals.editingStatus': 'Editing Status',
  'modals.exportingServiceOrders': 'Exporting activity(ies)',
  'modals.replyingServiceOrder': 'Replying to activity',
  'modals.serviceOrderResume': 'Activity summary',
  'modals.cloningServiceOrder': 'Cloning activity',
  'modals.editingServiceOrder': 'Editing activity',
  'modals.creatingServiceOrder': 'Creating activity',
  'modals.editingServiceOrders': 'Editing activities',
  'modals.registeringServiceOrders': 'Registering activities',
  'modals.sendingPublicExecutionLink': 'Sending public execution link',
  'modals.replies': 'Replies',
  'modals.editingDynamicServiceOrders': 'Editing Dynamic Activities',
  'modals.creatingDynamicServiceOrders': 'Creating Dynamic Activities',
  'modals.editingStockItem': 'Editing item',
  'modals.creatingStockItem': 'Creating item',
  'modals.details': 'Details',
  'modals.transfers': 'Transfers',
  'modals.transferHistory': 'Transfer history',
  'modals.formEdit': 'Form Edit',
  'modals.formsEdit': 'Forms Edit',
  'modals.formReply': 'Form Reply',
  'modals.actionPlans': 'Action plans',
  'modals.editingAsset': 'Editing Item',
  'modals.creatingAsset': 'Registering Item',
  'modals.templatesList': 'Templates List',
  'modals.editingTemplate': 'Editing template',
  'modals.creatingTemplate': 'Creating template',
  'modals.templateDetails': 'Template Details',
  'modals.documentGeneration': 'Document Generation',
  'modals.documentsHistory': 'Documents History',
  'modals.cloningChecklist': 'Cloning checklist',
  'modals.chooseTemplate': 'Choose a template',
  'modals.automations': 'Automations',
  'modals.templates': 'Templates',
  'modals.automationDetails': 'Automation Details',
  'modals.editingAutomation': 'Editing automation',
  'modals.creatingAutomation': 'Creating automation',
  'modals.triggerFired': 'Trigger fired',
  'modals.qrCodeMenus': 'QR Code Menus',
  'modals.editingLinktree': 'Editing Linktree',
  'modals.creatingLinktree': 'Creating Linktree',
  'modals.publicLinks': 'Public Links',
  'modals.editPublicToken': 'Edit Public token',
  'modals.newPublicToken': 'New Public token',
  'modals.publicToken': 'Public Token',
  'modals.newIntegration': 'New integration',
  'modals.newAccount': 'New account',
  'modals.editingWebhook': 'Editing webhook',
  'modals.creatingWebhook': 'Creating webhook',
  'modals.newConfiguration': 'New configuration',
  'modals.webhookDetails': 'Webhook details',
  'modals.routines': 'Routines',
  'modals.editingRoutine': 'Editing routine',
  'modals.creatingRoutine': 'Creating routine',
  'modals.editingPermissions': 'Editing permissions',
  'modals.nonCompliance': 'Non-compliance',
  'modals.nonComplianceBulkEdit': 'Bulk edit non-compliance',
  'modals.actionPlan': 'Action Plan',
  'modals.imports': 'Imports',
  'modals.export': 'Export',
  'modals.exports': 'Exports',
  'modals.buckets': 'Batches',
  'modals.newBucket': 'New batch',
  'modals.editingView': 'Editing view',
  'modals.editingFields': 'Editing additional fields',
  'modals.createStrongPassword': 'Create a strong password',
  'modals.alert': 'Alert',
  'modals.formInvites': 'Form invites',
  'modals.semaphoreConfig': 'Semaphore configuration',
  'modals.availabilityStatusSourceConfig': 'Availability Status Source',
  'modals.automaticDistribution': 'Automatic distribution',
  'modals.survey': 'Survey',
  'modals.generatingQrCode': 'Generating QR Code',
  'modals.generatingQrCodes': 'Generating QR Codes',
  'modals.groupedItems': 'Grouped items',
  'modals.newTechnician': 'New technician',
  'modals.registeredTechnicians': 'Registered Technicians'
}
